import React from "react";
import PropTypes from "prop-types";
import formField from "../formField";

export function FormInput({
  type = "text",
  className = "",
  input,
  autoComplete = "off",
  readOnly = false,
  disabled = false,
  inputProps = {}
}) {
  return (
    <input
      type={type}
      autoComplete={autoComplete}
      id={input.name}
      className={`form-control ${className}`}
      readOnly={readOnly}
      disabled={disabled}
      {...input}
      {...inputProps}
    />
  );
}

export default formField(FormInput);

FormInput.propTypes = {
  input: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  autoComplete: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  inputProps: PropTypes.shape({
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormInput/FormInput.jsx